<!--
================================================
Un composant affichant la liste des users de l'organisation

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/team/users

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="UserListComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
<!--        {{'Hello ! :) I am ' + $options.name}}-->

        <!--  Bloc placeholder affiché pendant le chargement des users-->
        <div class="appBloc" id="blocLoadingUsers" v-if="!componentIsReady">
            <table class="table is-fullwidth">
                <tbody>
                <loading-timerecord-comp v-for="index in 10" :key="index"></loading-timerecord-comp>
                </tbody>
            </table>
        </div>

        <!-- liste des users -------------------------------------------->
        <div v-else>
            <div class="table-container"> <!-- rend le tableau scrollable si besoin (pour les mobiles)-->
              <table class="appBloc table is-fullwidth user" id="userTable">

              <thead>
              <tr class="lineUser">
                <th colspan="" class="is-uppercase">#</th>
                <th colspan="" class="is-uppercase">{{ $t('membre') }}</th>
                <th colspan="" class="is-uppercase">{{ $t('email') }}</th>
                <th colspan="" class="is-uppercase"> {{ $t('statut') }}</th>
                <th colspan="" class="is-uppercase" v-if="$auth.hasRole('ROLE_ADMIN')"> {{ $t('TauxHoraireFacturable') }}</th>
                <th colspan="" class="is-uppercase is-hidden-touch is-hidden-desktop-only">{{ $t('accès') }}</th>
                <th colspan="" class="is-uppercase is-hidden-touch is-hidden-desktop-only">{{ $t('DateCréation') }}</th>
                <th colspan="" class="is-uppercase "></th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="(user,index) in users" v-bind:key="user.slug" v-bind:id="'user_'+user.slug"
                  v-bind:class="'user_'+index">

                <!-- index utilisateur -->
                <td class="index">{{ index + 1 }}</td>

                <!-- username -->
                <td class="userName">

                  <span >
                            <!--   user encore en statut "invité" On ne connait pas le nom prénom à afficher -->
                            <span v-if="user.isActive == true && user.firstname==null && user.name==null">
                              <font-awesome-icon class="icon" :icon="['fas', 'envelope']"/>
                            </span>
                            <span v-else-if="user.isActive==false" v-bind:title="$t('lUtilisateurtEstArchivé')">
                                <font-awesome-icon  class="icon archivedUser" :icon="['fas', 'user-slash']" />
                            </span>
                            <span v-else>
                                <font-awesome-icon  v-bind:style="{color:'#'+ user.color}" class="icon" :icon="['fas', 'user']" />
                            </span>

                            <!--// Lien de modification si l'user a la permission d'édition -->
                            <a v-if="userCanEditUser()"
                               v-bind:title="$t('modifierLUtilisateur')" class="" v-on:click="modifyUser(user)"
                               v-bind:class="{'archivedUser':user.isActive==false}">
                              <span class="email" v-if="user.firstname ==null && user.name == null">{{user.email}}</span>
                              <span class="name" v-else>{{user.firstname + ' '+user.name}}</span>
                            </a>

                            <!--// affichage du nom du membre si l'user n'a pas de permission d'édition -->
                            <span v-else  class="" v-bind:class="{'archivedUser':user.isActive==false}">
                              <span class="email" v-if="user.firstname ==null && user.name == null">{{user.email}}</span>
                              <span class="name" v-else>{{user.firstname + ' '+user.name}}</span>
                            </span>
                        </span>


                </td>

                <td class="email" v-bind:title="$t('email')">
                  <a v-bind:title="$t('envoyerUnEmailAX', {email : user.email})"  target="_blank" v-bind:href="'mailto:'+user.email">{{ user.email }}</a>
                </td>

                <!--- Statut : actif, désactivé, invité -->
                <td class="status">

                        <span class="statusTag tagInvited"
                              v-if="user.isActive==true && user.isVerified !=true && user.lastLogin == null">
<!--                        <span class="statusTag tagInvited"  v-if="user.isActive && user.isVerified !=true">-->
                            <font-awesome-icon class="icon" :icon="['fas', 'envelope']"/>{{ $t('invité') }}
                        </span>

                  <span class="statusTag tagActive" v-else-if="user.isActive">
                            <font-awesome-icon class="icon" :icon="['fas', 'user']"/>{{ $t('actif') }}
                        </span>

                  <span class="statusTag tagArchived" v-else-if="user.isActive==false">
                            <font-awesome-icon class="icon" :icon="['fas', 'user-slash']"/>{{ $t('archivé') }}
                        </span>

                </td>

                <!--- Taux horaire -->
                <td class="hourRate" v-if="$auth.hasRole('ROLE_ADMIN')">


                  <span class="" v-if="user.hourRate===0"
                        :content="$t('leTauxHoraireDeLUtilisateurEst0')"
                        v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip'}"
                  >
                      {{user.hourRate}} {{currencyToSign($auth.getActiveWorkspaceCurrency())}}  {{$t('/heure')}} ⚠️
                  </span>
                  <span v-else class="">
                    <b>{{user.hourRate}} {{currencyToSign($auth.getActiveWorkspaceCurrency())}}</b>  {{$t('/heure')}}
                  </span>

                </td>

                <!-- ROLE UTILISATEUR ---->
                <td class="permission is-uppercase is-hidden-touch is-hidden-desktop-only">
                        <span class="tagUser" v-if="user.roles.includes('ROLE_OWNER')">
                            <font-awesome-icon class="icon crownIcon" :icon="['fas', 'crown']"/>{{ $t('Propriétaire') }}
                        </span>
                  <span class="tagUser" v-else-if="user.roles.includes('ROLE_ADMIN')">{{ 'administrateur' }}</span>
                  <span v-else-if="user.roles.includes('ROLE_USER')">{{ '-' }}</span>
                </td>

                <!---Created At -->
                <td class="createdAt is-hidden-touch is-hidden-desktop-only" v-bind:title="$t('DateCréation')">
                  {{ $moment(user.createdAt).fromNow() }}
                </td>

                <!-- NOTE : On masque le menu pour les users en cours d'invitation -->
                <td class="menuLink" v-bind:title="$t('afficherLeSousMenu')">
                  <font-awesome-icon
                      v-if="userCanEditUser()"
                      v-bind:id="'menuOpener_'+user.slug"
                      v-on:click="showMenu(index)" class="icon menuOpener"
                      :icon="['fas', 'ellipsis-v']"/>
                </td>

                <div class="menu" v-show="user.showMenu" v-on:mouseleave="hideMenus()">
                  <ul>
                    <li v-on:click="modifyUser(user)" class="editLink">
                      <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>
                      <a>{{ $t('modifier') }}</a>
                    </li>

                    <li class="unArchiveLink" v-if="user.isActive==false" v-on:click="deactivateUser(user,'restore')">
                      <font-awesome-icon class="icon" :icon="['fas', 'user']"/>
                      <a>{{ $t('réactiver') }}</a>
                    </li>

                    <!-- Un user ne peut pas se désactiver lui-même ni désactiver un ROLE_OWNER -->
                    <li class="archiveLink" v-else-if="
                            user.isActive == true
                            && $auth.getUserSlug() != user.slug
                            && ! user.roles.includes('ROLE_OWNER') " v-on:click="deactivateUser(user,'archive')">
                      <font-awesome-icon class="icon" :icon="['fas', 'user-slash']"/>
                      <a>{{ $t('désactiver') }}</a>
                    </li>

                  </ul>
                </div>
              </tr>

              </tbody>
            </table>
            </div>
        </div>


    </div>

<!--    https://www.npmjs.com/package/v-click-outside-->
<!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../../mixins/SentryMixin.js";
    import LoadingTimerecordComp from "../PlaceholderTimerecordComp";

    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../../mixins/InterceptorMixin.js";
    import _ from 'lodash'
    import CurrencyMixin from "@/mixins/CurrencyMixin";
    import TrackingMixin from "@/mixins/TrackingMixin";

    // import vClickOutside from 'v-click-outside'

    export default {
        name: 'UserListCom', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, CurrencyMixin, TrackingMixin],
        components: {LoadingTimerecordComp},

        // directives: {
        //     clickOutside: vClickOutside.directive
        // },

        // props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            // placeholder : String, // attribut placeholder du champ
        // },
        data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                componentIsReady : false, // indique quand le composant est prêt à être affiché (users chargés)
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                users: state => state.UsersView.users,
                themeToDisplay: state => state.app.themeToDisplay
            }),

            //----------------------------------------------

            // vuex 2-way data binding forms https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
            // email: {
            //     get () {return this.$store.state.user.email},
            //     set (value) {this.$store.commit('UpdateUserEmail', value)}
            // },

            //----------------------------------------------

            // other computed props :


        },
        watch: {
            // Chargement initial des users : on a besoin d'attendre que user soit récupéré dans le store pour charger les users (slug user requis dans la route)
            // user: function () {
            //     if (this.user != null) {
            //         this.loadUsers()
            //     }
            // },
        },


        methods: {

            /**
             * Met le store à jour avec editedUser
             * @param editedUser object le user mis à jour à mettre dans le store
             * inspiré de https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
             *
             */
        updateUserInStore(editedUser){
            // on remplace le user édité dans le store

            // Trouve l'index de l'objet à remplacer dans le store
            var index = _.findIndex(this.users, {slug: editedUser.slug});

            editedUser.showMenu = false // on définit l'affichage du .menu à false

            // Remplace l'objet à l'index précédemment trouvé
            this.users.splice(index, 1, editedUser);

        },



            /**
             * Récupère les users accessibles pour l'utilisateur.
             *
             * @param String filter | une chaîne pour filtrer par nom des users
             */
            loadUsers(filter) {
                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users`,
                    {
                        params: {
                            filter: filter,
                            sort: 'desc', // on récupère les plus récents en premier
                            archive: 'all', // on récupère les users archivés + actifs
                            workspace: self.$auth.getActiveWorkspace(),
                        },
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on injecte une propriété 'showMenu' dans chaque users (qui sert à gérer l'affichage des .menu)
                        let users = []
                        response.data.forEach(function (value) {
                            value.showMenu = false;
                            users.push(value);
                        })

                        // stockage dans le store
                        self.$store.commit('UpdateUsersViewUsers', response.data)
                        self.componentIsReady = true

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0038'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id": errorCode,"detail": "error fetching users"})
                          self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching users', 'fatal': false})
                          self.$sentry.captureMessage(`Error ${errorCode} > "error fetching users : ${error}`, 'error')
                        }
                    })
                    .then(() => {
                        // toujours exécuté
                    })
            },


            /**
             * Masque tous les éléments .menu
             **/
            hideMenus() {
                this.users.forEach(function (value) {
                    value.showMenu = false;
                })
            },
            /**
             * Affiche l'élément .menu dont index est passé.
             * @param index int | Index du menu à afficher
             */
            showMenu(index) {
                this.hideMenus(); // on masque un éventuel .menu affiché au préalable
                this.users[index].showMenu = true;
            }

            /**
             * Ouvre la modal user management pour modifier un user
             * @param userToModify L'objet User à modifier
             */
            , modifyUser(userToModify) {
                this.$root.$emit('show_modal_user_management','edition', userToModify)
            }

            /**
             * Archive/restaure un user
             * @param user Object user à archiver
             * @param mode String L'action à effectuer (désactiver/activer)
             */
            ,deactivateUser(user,mode){

                const params = {}
                switch (mode) {
                    case  'archive': params.isActive = false; break;
                    case  'restore': params.isActive= true; break;
                }

                let self = this
                return self.$http.patch(`/organizations/${self.organizationSlug}/users/${user.slug}`,
                        params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on maj le store avec le user modifié
                        self.updateUserInStore(response.data)

                        // tracking mixpanel
                        self.$mixpanel.track("User deactivated", {"user":response.data.slug});
                        self.ga4GlobalEventTrack('User deactivated' , {"user":response.data.slug})

                      return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0039'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error archiving user"})
                          self.$gtag.exception({'description': 'error '+errorCode + ' | error archiving user', 'fatal': false})

                          self.$sentry.captureMessage(`Error ${errorCode} > error archiving user : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

            /**
             * Déclenche l'ouverture de la ModalDeleteUserComp
             * @param user Object user à supprimer
             */
            // ,openModalDeleteUser(user){
            //     this.$root.$emit('show_modal_delete_user',user)
            // }


            /**
             * Retourne true si l'utilisateur actuel à le droit de modifier le user
             * @param user Object | le user à tester
             * @return {boolean}
             */
            ,userCanEditUser(){
                // Pour modifier un User il faut être ROLE_ADMIN dans la même organisation
                if (this.$auth != null) {

                    if (this.$auth.hasRole('ROLE_ADMIN') && this.$auth.getOrganization() == this.organizationSlug) {
                        return true
                    }
                }

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            // chargement initial des users
            this.loadUsers()

            // listener de l'event new_user_invited, pour m.a.j les users si un user est invité

            this.$root.$on('new_user_invited', () => {

                this.loadUsers()

            })

            // listener de l'event user_edited, pour m.a.j les users si un user est modifié
            this.$root.$on('user_edited', (userEdited) => {
               this.updateUserInStore(userEdited)
            })

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar";
    @import "../../assets/css/bulmaResponsiveDep";

    #UserListComp{

      table.user{

      .index{
        padding-left: 2rem ;
        @include touch{
          padding-left: 1rem;
        }
      }
        .icon{
            padding-top: 0.5rem;
            margin-right: 0.2rem;
        }

        .userName{
            padding-left: 2rem;
            min-width:$variableTxtMinWidth;
            @include mobile{
                padding-left: 0rem;
            }
            font-weight: bold;

            $nameColor: #666;
            .name {
                text-transform: capitalize;
                color:$nameColor;
                &.archivedUser {
                    color: #999;
                }
            }
            .email{
              color: $nameColor;
            }

            .icon{
                margin-right: 0.4rem ;
                &.archivedUser {
                    color:#ccc ;
                }
            }

        }
        .email{
          a { color:$brandFourth;}
        }
        .owner{
            .fullname{
                text-transform: capitalize;
            }
        }
        .clientName{
            font-weight: bold;
            color: $clientColor;
        }
        .isPrivate{
                .private{
                    color:$brandThird;
                    &.icon{
                        color:$brandThird;
                    }
                }
                .public{
                    color:#999;
                    &.icon{
                        color:#999
                    }
                }
        }

        .statusTag{
          display: inline-block;
          .icon{
            padding: 0;
            vertical-align: middle;
          }
        }
        .tagArchived{
            background:transparent;
            padding: .2rem 0.5rem;
            border-radius: 3px;
            border: dashed 1px #ccc;
            font-size: 0.85rem;
            color:$brandFourth;
            min-width: 5.5rem;
        }
        .tagActive{
            background:transparent;
            border:dashed 1px $brandPrimary;
            padding: .2rem 0.5rem;
            border-radius: 3px;
            font-size: 0.85rem;
            color:$brandPrimary;
            .icon{
              color: $brandPrimary;
            }
        }
        .tagInvited{
          border:dashed 1px #ccc;
            padding: .2rem 0.5rem;
            border-radius: 3px;
            font-size: 0.85rem;
          color:$brandOrange;
          .icon{color: $brandOrange}
        }
        .tagUser{
            padding: 0.3rem 0.5rem;
            border-radius: 3px;
            font-size: 0.85rem;
            font-weight: bold;
            text-transform: capitalize;
        }
        .hourRate{
          text-align: center;
        }
    }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {
        .userName{
          $nameColor:$darkContrastTxt;
          .name {
            color: $nameColor !important;
            &.archivedUser {
              color: $disabledTableItemColor !important;
            }
          }
          .email{
            color: $nameColor !important;
          }
          .icon{
            &.archivedUser {
              color:$disabledTableItemColor !important;
            }
          }
        }
        .email{
          a { color:$darkTxt !important;}
        }
        .tagActive{
          background-color: transparent !important;
          border-color: $darkBg3 !important;
          color:$brandPrimary !important;
          border: dashed 1px $brandPrimary !important;

        }
        .tagArchived{
          color:$darkTxt !important;
          border-color:darken($darkTxt,40%) !important;
        }
        .tagInvited{
          border-color: $darkLightBlue !important;

          background-color: transparent !important;
          color: $darkLightBlue !important;
          .icon{
            color: $darkLightBlue !important;

          }
        }



      }
    }


</style>
